export default [
  {
    name: 'API Documentation',
    path: '/documentation',
    component: () => import('./pages/AllDocumentation'),
    meta: {
      ability: [
        {
          resource: 'api-docs',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'API Endpoint Documentation',
    path: '/endpoint',
    component: () => import('./pages/EndpointDocumentation'),
    meta: {
      ability: [
        {
          resource: 'api-docs',
          actions: ['read'],
        },
      ],
    },
  },
]
